// Where a page may send the person back to after an outside flow: only to a page on this site.
// The value arrives in the address bar, so anyone can write a link that sets it; a value that is not
// a plain path on this site is replaced by the fallback, so the link cannot send them elsewhere.
//
// Written as plain CommonJS with no imports so the API server, which runs its files under plain
// node, can require this same file the browser bundle imports.

// Control characters, which browsers drop from an address before reading it.
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F]/;
const SCHEME = /^[a-z][a-z0-9+.-]*:/i;

/**
 * The value, decoded once, when it is a path on this site; otherwise the fallback.
 *
 * A path on this site starts with a single `/` (not `//` or `/\`, which browsers read as another
 * site), and holds no backslash, no scheme and no control character.
 *
 * @param {*} value
 * @param {string} [fallback='/wallet']
 * @returns {string}
 */
const safeReturnPath = (value, fallback = '/wallet') => {
  if (typeof value !== 'string' || value === '') return fallback;

  let path;
  try {
    path = decodeURIComponent(value);
  } catch (error) {
    return fallback;
  }

  const isOnSite =
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.includes('\\') &&
    !SCHEME.test(path) &&
    !CONTROL_CHARACTERS.test(path);

  return isOnSite ? path : fallback;
};

module.exports = { safeReturnPath };
